import React from 'react';

const User = ({ userId, sessionId, setUserId, setSessionId }) =>  {

  const guid = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
    return v.toString(16);
  });

  if(typeof(Storage) !== 'undefined' && userId !== ''){
    // check for user id
    if (localStorage.userId) {
      setUserId(localStorage.userId);
    } else {
      // set userId
      const userId = guid();
      localStorage.userId = userId;
      setUserId(userId);
    }
  } else {
    // if no local storage give state default user id
    setUserId('noLocalStorage');
  }

  // set initial sessionId
  if(sessionId === ''){
    setSessionId(guid());
  }

  return (
    <div></div>
  );
}

export default User;



/** WEBPACK FOOTER **
 ** ./src/components/User/User.js
 **/